import React, { Component, Fragment, ReactNode } from 'react';
import { connect } from 'react-redux';
import * as navigationActions from '@flow/store/navigation/actions';
import * as myFlowAPIActions from '@flow/store/myflow/API';
import { withRouteData } from "react-static";
import { SingleColumnLayout, SingleColumnLayoutContentWrapper, SingleColumnLayoutHeader } from '@flow/components/ui';
import { IPage } from 'types/IPage';
import { MyFlowState } from '@flow/store/myflow/reducer';
import { GetListWithId, HashMapItem, HashMapItems, SetInitialMyFlowData } from 'types/MyFlow';
import SEOTags from '@flow/components/seo/SEOTags';
import { renderContent } from '@flow/scenes/default/ui';
import * as myFlowActions from '@flow/store/myflow/actions';
import { Day, filterSelectedEvents, sortEventItemsByDay, sortEventsByTimeDESC } from '@flow/utils/helperUtils';
import { renderDayTitle } from '@flow/scenes/schedule/ui/Schedule';
import {
  MyFlowContent,
  MyFlowScheduleDayList,
  MyFlowScheduleListsWrapper,
} from '@flow/scenes/schedule/ui';
import { ListActionItem } from '@flow/scenes/schedule/ui/ListActionItem';
import { DingbatAnimation } from '@flow/components/animation/DingbatAnimation';
import * as SVGData from '@flow/components/animation/data/softSplash.json';

interface Props {
  appLanguage: IAppLanguage;
  programPageNavigation: ProgramPageNavigation;
  page: IPage;
  setLanguage: any;
  myFlow: MyFlowState;
  initialIdHashMap: HashMapItems;
  setInitialData: (params: SetInitialMyFlowData) => any;
  match: any;
  history: any;
  getListWithId: (params: GetListWithId) => any;
  loadingUserList: () => any;
}

class MyFlow extends Component<Props, {}> {

  constructor(props: Props) {
    super(props);
  }

  componentWillMount() {
    const {
      appLanguage,
      page,
      initialIdHashMap,
      setLanguage,
      setInitialData,
      history: {
        location: {
          search,
        }
      },
      getListWithId,
      myFlow: {
        myFlowPage: {
          loading,
        },
      },
      loadingUserList
    } = this.props;

    const lang_versions = page && page.lang_versions;

    setLanguage({ appLanguage, lang_versions });
    setInitialData({ hashMapItems: initialIdHashMap });

    if (!loading && typeof window !== 'undefined') {
      loadingUserList();
      const potentialListId = search.substring(6);
      getListWithId({
        listId: potentialListId,
      });
    }
  }

  componentWillReceiveProps({
    appLanguage,
    page,
    initialIdHashMap,
  }: Props) {
    const {
      setLanguage,
      setInitialData,
    } = this.props;

    if (appLanguage.code !== this.props.appLanguage.code) {
      const lang_versions = page && page.lang_versions;

      setLanguage({ appLanguage, lang_versions });
      setInitialData({ hashMapItems: initialIdHashMap });
    }
  }

  render() {
    const {
      page,
      myFlow,
    } = this.props;

    const { content_group } = page;

    const selectedEventsHashMap = filterSelectedEvents(myFlow.eventIdHashMap, myFlow.myFlowPage.idList);
    const eventsByDay = sortEventItemsByDay(selectedEventsHashMap, sortEventsByTimeDESC);

    return <Fragment>
      <SEOTags page={page}/>
      <SingleColumnLayout>
        <SingleColumnLayoutHeader>
          <h2>{page.title}</h2>
        </SingleColumnLayoutHeader>
        <SingleColumnLayoutContentWrapper>
          {renderContent(content_group)}
          {this._renderMyFlowContent(eventsByDay)}
        </SingleColumnLayoutContentWrapper>
      </SingleColumnLayout>
    </Fragment>;
  }

  private _renderMyFlowContent = (eventsByDay: Day[]): ReactNode => {
    const {
      appLanguage,
      myFlow: {
        myFlowPage: {
          loading,
        },
      },
    } = this.props;

    if (loading) {
      return (
        <DingbatAnimation
          width={40}
          height={40}
          shape={SVGData}
          type={'generic'}
          animationIndex={undefined}
          autoPlay={true}
        />
      );
    }

    return (
      <MyFlowContent style={{ height: 'auto', textAlign: 'left' }}>
        <MyFlowScheduleListsWrapper>
          {eventsByDay.map((day: Day, idx: number) => (
            <MyFlowScheduleDayList key={idx}>
              <h2 className='day-title' style={{textTransform: 'uppercase'}}>
                {renderDayTitle(appLanguage.code, day.date, 'ddd DD.M.')}
              </h2>
              <ul>
                {day.events && day.events.map((item: HashMapItem, index: number) =>
                  <ListActionItem
                    item={item}
                    key={index}
                    showVenue={true}
                    staticItem={true}
                  />
                )}
              </ul>
            </MyFlowScheduleDayList>
          ))}
        </MyFlowScheduleListsWrapper>
      </MyFlowContent>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(navigationActions.setLanguage(appLanguage, lang_versions));
    },
    setInitialData: (params: SetInitialMyFlowData) => dispatch(myFlowActions.setInitialData(params)),
    getListWithId: (params: GetListWithId) => dispatch(myFlowAPIActions.getListWithId(params)),
    loadingUserList: () => dispatch(myFlowAPIActions.loadingUserList()),
  };
};

export default withRouteData(connect(
  (state: any) => ({
    myFlow: state.myFlowReducer,
  }), mapDispatchToProps
)(MyFlow));


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/my-flow/MyFlow.tsx